import React, { Component } from "react";
import PropTypes from "prop-types";
import { logFeatureUsage } from '../../../lib/analytics/AnalyticsController';

/**
 * A generic component which wraps it's provided children in an anchor tag.
 * Adds analytics functionality by attaching an onClick event listener to track when the component is clicked.
 *
 * @class TrackedAnchor
 */
class TrackedAnchor extends Component {
	constructor(props) {
		super(props);

		this.handleOnClick = this.handleOnClick.bind(this);
	}

	/**
	 * Logs when the user clicks on the TrackedAnchor.
	 * NOTE: The current logging system only logs 1 unique interaction per session.
	 * @memberof TrackedAnchor
	 */
	handleOnClick() {
		logFeatureUsage(this.props.featureType, this.props.srcId, this.props.destId);
	}

	render() {
		return (
			<a href={this.props.href}
				title={this.props.title}
				alt={this.props.alt}
				target={this.props.target}
				className={this.props.anchorClass}
				onClick={this.handleOnClick}>
				{this.props.children}
			</a>
		);
	}
}

TrackedAnchor.propTypes = {
	// the unique "feature type" associated with the item being wrapped. See FeatureTypes constants for more information.
	featureType: PropTypes.object.isRequired,
	// the unique ID associated with the original item the user is interacting with
	srcId: PropTypes.string.isRequired,
	// the unique ID of the "destination" item (ex: link, title, hover, newsletter name, etc.)
	destId: PropTypes.string.isRequired,
	// "href" attribute of the anchor tag. The URL where the hyperlink points to.
	href: PropTypes.string.isRequired,
	// "target" attribute. Where to display the linked URL (ex: _self, _parent, _top, etc.)
	target: PropTypes.string,
	// optionally provide a custom CSS class to style the anchor tag
	anchorClass: PropTypes.string,
	children: PropTypes.node
}

export default TrackedAnchor;



// WEBPACK FOOTER //
// ./src/react/views/generic/TrackedAnchor.jsx